module.exports = __webpack_public_path__ + "static/media/error.335b4f0b.png";